import React, { ReactNode } from "react"
import TopBar from "./TopBar"
import Sidebar from "./Sidebar"
import ErrorBoundary from "./ErrorBoundary"
import { THEME } from "../config/theme"

const Layout: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        fontFamily: THEME.fonts.primary,
      }}
    >
      <TopBar />
      <div style={{ display: "flex", flex: 1, minHeight: "calc(100vh - 48px)" }}>
        <Sidebar />
        <main
          style={{
            flexGrow: 1,
            overflowY: "auto",
            padding: "24px",
            background: THEME.colors.neutral.light.background,
            minHeight: "calc(100vh - 48px)",
            boxSizing: "border-box",
          }}
        >
          {/* The last resort, under every page. A surface that wraps itself
              more tightly (the audit worklist, the row drawer) keeps its own
              failure local; anything that does not at least keeps the top bar
              and sidebar alive, so the operator can navigate away instead of
              staring at a white screen. */}
          <ErrorBoundary surface="page">{children}</ErrorBoundary>
        </main>
      </div>
    </div>
  )
}

export default Layout
